import React from 'react';

import './index.scss';

export const SkeletonLine = ({ className, style }: { className?: string, style?: { [key: string]: string } }) => {
  return <div className={`skeleton-line ${className}`} style={style} />;
};
